module.exports = __webpack_public_path__ + "m4u1.png?6d6d21155bdd68d0b0182aa1670a31de";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m4u1.png
// module id = 224
// module chunks = 0